<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 20"
    :fill="iconColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5009 6.11655L14.2176 3.83321C13.9196 3.55329 13.5291 3.39268 13.1203 3.38192C12.7116 3.37117 12.3132 3.51102 12.0009 3.77488L4.5009 11.2749C4.23154 11.5465 4.06382 11.9026 4.0259 12.2832L3.66756 15.7582C3.65634 15.8803 3.67218 16.0033 3.71395 16.1185C3.75572 16.2338 3.8224 16.3384 3.90923 16.4249C3.9871 16.5021 4.07945 16.5632 4.18098 16.6047C4.28251 16.6462 4.39123 16.6672 4.5009 16.6665H4.5759L8.0509 16.3499C8.43156 16.312 8.78759 16.1442 9.05923 15.8749L16.5592 8.37488C16.8503 8.06735 17.0076 7.65697 16.9967 7.23366C16.9858 6.81035 16.8075 6.40864 16.5009 6.11655ZM7.9009 14.6832L5.4009 14.9165L5.6259 12.4165L10.3342 7.76655L12.5842 10.0165L7.9009 14.6832ZM13.6676 8.89988L11.4342 6.66655L13.0592 4.99988L15.3342 7.27488L13.6676 8.89988Z"
    />
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [Number, String],
    required: false,
    default: 24
  },
  height: {
    type: [Number, String],
    required: false,
    default: 24
  },
  iconColor: {
    type: String,
    required: false,
    default: '#232323'
  }
})
</script>
